<template>
  <transition name="fade" appear>
    <div class="modal" v-if="show">
      <div
        class="modal__background"
        :style="{ backgroundColor: bgColor }"
        @click="$emit('hideModal')"
      ></div>
      <div class="modal__body">
        <IconButton
          v-if="close"
          class="modal__close button--lg"
          :class="{ modal__close_circle: closeCircle, modal__close_left: closeLeft }"
          @click="$emit('hideModal')"
        >
          <IconClose v-if="!closeBold" width="20" height="20" />
          <IconCloseBold v-if="closeBold" width="30" height="30" />
        </IconButton>
        <transition name="pop" appear>
          <div class="modal__body_content" v-if="show">
            <slot></slot>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import IconButton from "@/components/buttons/IconButton.vue";
import IconClose from "@/components/icons/IconClose.vue";
import IconCloseBold from "@/components/icons/IconCloseBold.vue";
export default {
  name: "modal",
  props: {
    bgColor: { type: String, default: "#fff" },
    show: { type: Boolean, default: false },
    close: { type: Boolean, default: true },
    closeCircle: { type: Boolean, default: false },
    closeBold: { type: Boolean, default: false },
    closeLeft: { type: Boolean, default: false },
  },
  components: { IconButton, IconClose, IconCloseBold },
};
</script>
<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed !important;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  opacity: 1;
  &--fullscreen {
    .modal__body_content {
      width: auto;
      min-width: 30%;
      max-width: 85%;
      padding: 0;
    }
  }
  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    cursor: pointer;
  }
  &__body {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: $white;
    padding: 5.5rem 0;
    &_content {
      position: relative;
      width: 105rem;
      height: 100%;
      //max-width: 90vw;
      z-index: 9;
      padding: 0 5vw;
      overflow-y: auto;
      //overflow: hidden;
      @media only screen and (max-width: $xl) {
      }
      @media only screen and (max-width: $md) {
        width: 95rem;
        padding: 0 2vw;
      }
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        padding: 8rem 0 20px;
      }
    }
  }
  &__close {
    position: absolute;
    right: 4rem;
    top: 4rem;
    z-index: 10;
    @media only screen and (max-width: $md) {
      right: 2rem;
      top: 2rem;
    }
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      right: 1rem;
      top: 1rem;
    }
    @media (max-width: $xxs) {
      width: 5.5rem;
    }
    &_circle {
      width: 7rem;
      border-radius: 50%;
      border: 2px solid $black;
      @media (max-width: $xxs) {
        width: 5.5rem;
      }
    }
    &_left {
      right: auto;
      left: 4rem;
      @media only screen and (max-width: $md) {
        left: 2rem;
      }
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        left: 1rem;
      }
    }
  }
  &--xs {
    .modal__body {
      max-width: 88rem;
      height: auto;
      border-radius: 14px;
      &_content {
        padding: 7.5rem 9rem;
      }
    }
    .modal__close {
      right: 2rem;
      top: 2rem;
      height: 6rem;
      padding: 0 12px;
    }
  }
  &--xxs {
    .modal__body {
      max-width: 70rem;
      height: auto;
      border-radius: 14px;
      padding: 0;
      &_content {
        padding: 4.6rem 12rem;
      }
    }
    .modal__close {
      right: 2rem;
      top: 2rem;
      height: 6rem;
      padding: 0 12px;
    }
  }
  &--opacity-black {
    .modal__background {
      background-color: rgba($color: $black, $alpha: 0.4);
    }
  }
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-leave-to {
  transition-delay: 0.3s;
}

.pop-enter-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.3s linear;
}
.pop-leave-active {
  transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.2s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(-50%, -50%);
}
</style>
